module.exports = Studio.libraries['filesaver.js-npm'];